import React from 'react';
import MoonLoader from 'react-spinners/MoonLoader';

function LoaderCover({loading}) {
    if(!loading) return null;
    return (
        <div className='sweet-loading'>
            <div className="loading-container">
                <MoonLoader
                    css={{
                        display: 'block',
                        margin: '0 auto',
                        borderColor: '#f70000',
                        opacity:0.1
                    }}
                    sizeUnit={"px"}
                    size={60}
                    color={'#f70000'}
                    loading={loading}
                />
            </div>
      </div>
    ) 
}

export default LoaderCover


// WEBPACK FOOTER //
// ./src/features/commonUI/loadingCover.js